/* eslint-disable no-use-before-define */
/* eslint-disable eqeqeq */
import React, { useEffect, useState, useCallback } from "react";
import { Modal, Button, Jumbotron } from "react-bootstrap";
import { useSelector } from "react-redux";
import { envConfig, unifiedEnvConfig } from "../../../constants/api-endpoint";
import { httpGet, httpPost } from "../../../utility/requestHelper";
import {
  CONSTANTS,
  COOKIE,
  HTTP_CODES,
  LANGUAGE_CODES,
  MEDIA_TYPES,
  SOCIAL_PERPAGE_LIMIT,
  VERTICALS,
  REPORT_TYPES,
} from "../../../constants/app-constant";
import {
  dateFormat,
  getKeyByValue,
  getSearchApiDateFormat,
  getSocialApiDateFormat,
  groupBy,
} from "../../../utility/common-methods";
import Loader from "../../Shared/Loader";
import { getCookie } from "../../../utility/cookieProvider";
import EmbededFeedWidget from "../Analysis/EmbededFeedWidget";
import SingleFeedItem from "./PrintAndOnline/SingleFeedItem";
import ShareArticle from "../../Shared/ShareArticle";
import { ModalCloseIcon, NoFeedIcon } from "../../Icons/icons.component";
import NoDataMessage from "../../Shared/NoDataMessage";
import SingleSocialFeedItem from "./Social/SingleSocialFeedItem";
import BlogsAndForumFeedItem from "./BlogAndForum/BlogsAndForumFeedItem";
import TopicWiseNewsContainer from "./PrintAndOnline/TopicWiseNewsContainer";
const { EMPTY_OBJECT, REPLIES, RETWEETS, QUOTED, ORIGINALS } = CONSTANTS;
const { V_BLOG, V_FORUM, V_ONLINE, V_PRINT, V_SOCIAL } = VERTICALS;
const MAX_FEED_COUNT = 50;

const formatData = (data = {}, isPrint) => {
  try {
    console.log(
      Object.keys(data)
        .map((obj) => {
          return data[obj][!isPrint ? "Online" : "Print"];
        })
        .flat()
        .filter((e) => e)
    );
    //gets print property of all entity and combines it on single entry
    return Object.keys(data)
      .map((obj) => {
        return data[obj][!isPrint ? "Online" : "Print"];
      })
      .flat()
      .filter((e) => e);
  } catch (e) {
    return [];
  }
};
export default function EmbededFeedsList({
  feedsParams,
  onCancel,
  widget,
  inlineGraphTypeOptions,
  onWidgetDelete,
  setWidgetCreationStatus,
  fetchWidgets,
  selectedDataType,
  isAnalysisReport,
  selectedInlineEdition,
  selectedInlineState,
  selectedInlinePublication,
  selectedFilter,
  twitterFeeds,
  insightFeeds = 0,
  topicId,
  countType,
  tabData,
  tonalities,
  widgetApiInProgress,
  endRange,
  startRange,
  selectedInlineInfluencerEntity,
  selectedInlineWCEntity,
  fromUserName,
  setFromUserName
}) {
  const [feeds, setFeeds] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [offset, setoffset] = useState(1);
  const [groupedSelectedArticle, setGroupedSelectedArticle] = useState({});
  const [embededFeedsParams, setEmbededFeedsParams] = useState(undefined);
  const [selectedFeeds, setSelectedFeeds] = useState([]);
  const [paginationData, setPaginationData] = useState("");
  const [selectedFeedsGroup, setSelectedFeedsGroup] = useState([]);
  const [activeKey, setActiveKey] = useState(-1);
  const [countryWiseFeeds, setCountryWiseFeeds] = useState({});
  const [selectedCountryFeeds, setSelectedCountryFeeds] = useState([]);
  const [showViewMore, setShowViewMore] = useState(true);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [showFeedsList, setShowFeedsList] = useState(true);
  useEffect(() => {
    setoffset(1);
    fetchFeeds(false);
  }, [embededFeedsParams, fetchFeeds]);

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || EMPTY_OBJECT;

  const {
    edition,
    state,
    to_date,
    from_date,
    type,
    publication,
    topic_ids,
    filterTags,
    entityId,
    tonality,
    reporter,
    ottChannel,
    clickedEntityName,
    language,
    keywords,
    useMutipleTopicsApi,
    channel_type,
    selectedInlineWCType,
    worldMapData,
    press_release,
    from_username,
    country,
    reporterId,
    category,
  } = embededFeedsParams || feedsParams;
  const isPrintAndOnline = type === V_PRINT || type === V_ONLINE;
  const isBlogAndForum = type === V_BLOG || type === V_FORUM;
  const isSocial = type == V_SOCIAL;
  const listLength =
    typeof groupedSelectedArticle === "object" &&
    Object.values(groupedSelectedArticle).length;
  const minimumOffset = isPrintAndOnline ? 0 : 1;
  const showPagination =
    !isPrintAndOnline && listLength >= MAX_FEED_COUNT && showViewMore;
  const isPrint = type == V_PRINT;
  const selectedClientId = selectedClient && selectedClient.id;

  const getCorrectTwitterType = (type) => {
    if (type == "Retweets" || type == "Quoted") {
      return RETWEETS;
    }
    if (type == "Original Tweets") {
      return ORIGINALS;
    }
    if (type == "Replies") {
      return REPLIES;
    } else {
      return null;
    }
  };

  useEffect(() => {
    getCorrectTwitterType(countType);
    getFeedSearchUrl();
  }, [countType]);

  useEffect(() => {
    if (
      (feeds &&
        feedsParams.worldMapData &&
        feedsParams.worldMapData.countryFeeds) ||
      (embededFeedsParams &&
        embededFeedsParams.embededFeedsParams &&
        feedsParams.worldMapData.countryFeeds)
    ) {
      setCountryWiseFeeds(
        feedsParams.worldMapData.countryFeeds ||
        embededFeedsParams.worldMapData.countryFeeds
      );
    }
  }, [feedsParams, embededFeedsParams, feeds]);

  useEffect(() => {
    const { countryFeeds, country } = worldMapData || {};
    if (country && countryFeeds) {
      let feeds = [];
      for (let c in countryFeeds) {
        if (c == country) {
          feeds = countryFeeds[c] && countryFeeds[c].feeds;
        }
      }
      setSelectedCountryFeeds(feeds);
    }
  }, [worldMapData]);

  useEffect(() => {
    setShowFeedsList(!!isMAVOrCCM());
  }, [isMAVOrCCM, widget]);

  const getCorrectPublication = useCallback(() => {
    if (!publication) {
      return null;
    }
    if (Array.isArray(publication) && publication.length) {
      return publication.map((p) => p.id);
    }
    if (publication.id) {
      return [publication.id];
    }
    return null;
  }, [publication]);

  let hasWorldMapData = useCallback(() => {
    return worldMapData && worldMapData.countryFeeds && worldMapData.country;
  }, [worldMapData]);

  const fetchFeeds = useCallback(
    (preserveData, limit) => {
      /* World map data is pre defined, need not to call the apis to fetch data*/
      if (hasWorldMapData()) {
        return;
      }
      if (!preserveData) {
        setGroupedSelectedArticle({});
        setFeeds({
          data: [],
          loading: true,
        });
      }
      const concept_email = getCookie(COOKIE.CONCEPT_USER_EMAIL) || null;
      const correctedOffset = preserveData
        ? (limit - 1) * MAX_FEED_COUNT
        : minimumOffset;
      const params = {
        client_id: selectedClient && selectedClient.id,
        download: "",
        email: concept_email,
        end_date: getSearchApiDateFormat(to_date),
        limit: 10000,
        media_type: type.toString(),
        start_date: getSearchApiDateFormat(from_date),
        offset: correctedOffset,
        /** For print and online, offset starts with 0,unlike social apis where it starts with 1. Hence reducing it by 1; **/
      };
      const publicationData = getCorrectPublication();
      if (topic_ids && topic_ids.length && entityId) {
        params.entities = topic_ids && topic_ids.map((e) => e && e.toString());
      }
      if (reporter && widget.report_type != REPORT_TYPES.EditionWiseNOATrend) {
        // params.source_type =
        //   type == VERTICALS.V_PRINT ? "Journalist" : "Online_Journalist";
        params.reporter = reporter;
      }
      if (
        widget.report_type == REPORT_TYPES.ThematicAnalysisTag ||
        widget.report_type == REPORT_TYPES.ThematicAnalysisEntity
      ) {
        params.category = category;
      }
      if (publicationData && publicationData.length) {
        params.publication_id = publicationData;
        params.publication_type = [];
      }
      if (edition && edition.length) {
        params.edition_id = edition;
      }
      if (state && state.length) {
        params.state = state;
      }
      if (tonality && tonality.length) {
        //https://webonise.atlassian.net/browse/CB-614
        const correctedTonality =
          tonality == "Neutral" ? "Informative" : tonality;
        params.tonality = correctedTonality;
      }
      if (language) {
        params.language = Array.isArray(language) ? language : [language];
      }
      if (keywords) {
        params.keywords = keywords;
      }
      if (press_release && press_release.length) {
        params.press_release = press_release;
      }
      if (useMutipleTopicsApi && !isPrintAndOnline) {
        fetchSocialWordcloudFeeds();
      } else if (!isPrintAndOnline) {
        fetchSocialFeedsFilterData(preserveData, limit);
      } else {
        setFeeds({
          loading: true,
        });
        httpPost(`${envConfig.PRINT_NEWS_TO_ENTITY}`, params)
          .then((res) => {
            const {
              data: { status, result, messsage },
            } = res || {};
            if (status === HTTP_CODES.SUCCESS && result && result.data) {
              const formattedData = formatData(result.data, isPrint);
              const { vTotalPrintCount, vTotalOnlineCount } = result.dataCount;
              const feedCount =
                type == V_PRINT ? vTotalPrintCount : vTotalOnlineCount;
              setPaginationData(feedCount);
              const updatedList =
                preserveData && feeds.data
                  ? [...feeds.data, ...formattedData]
                  : formattedData;
              setFeeds({
                loading: false,
                data: updatedList,
              });
              setGroupedSelectedArticle(
                groupBy(updatedList, isPrint ? "headline" : "article_id")
              );
            } else {
              setFeeds({
                data: [],
                loading: false,
                error: messsage,
              });
            }
          })
          .catch((e) => {
            setFeeds({
              data: [],
              loading: false,
              error: e,
            });
          });
      }
    },
    [
      edition,
      feeds.data,
      fetchSocialFeedsFilterData,
      fetchSocialWordcloudFeeds,
      from_date,
      getCorrectPublication,
      hasWorldMapData,
      isPrint,
      isPrintAndOnline,
      keywords,
      language,
      minimumOffset,
      press_release,
      reporter,
      ottChannel,
      selectedClient,
      to_date,
      tonality,
      topic_ids,
      type,
      useMutipleTopicsApi,
    ]
  );

  const getFeedSearchUrl = useCallback(
    (preserveData, page) => {
      const sDate = !twitterFeeds && insightFeeds == 0
        ? getSocialApiDateFormat(from_date)
        : dateFormat(from_date);
      const eDate = !twitterFeeds && insightFeeds == 0
        ? getSocialApiDateFormat(to_date)
        : dateFormat(to_date);
      const topicIds = (twitterFeeds && insightFeeds == 0 ? topicId : topic_ids[0]) || "";
      const client_id = selectedClient && selectedClient.id;
      const correctedPage = preserveData ? page : 0;
      let tempUrl = `/unifiedapi/social-feeds?client_id=${client_id}&page=${correctedPage}&perPage=${MAX_FEED_COUNT}&searchParams[from_date]=${sDate}&searchParams[to_date]=${eDate}&searchParams[topic_id]=${topicIds
        .toString()
        .trim()}&searchParams[type]=${type}`+(fromUserName !== undefined?"&searchParams[from_username]="+fromUserName:"");
      if (filterTags && filterTags.length) {
        tempUrl = `${tempUrl}&tagFilter[]=${filterTags[0] === "Not Rated" ? null : filterTags[0]
          }`;
      }
      if (channel_type) {
        if (!twitterFeeds && insightFeeds == 0 && Array.isArray(channel_type)) {
          channel_type.forEach((cType) => {
            tempUrl = `${tempUrl}&searchParams[channel_type][]=${cType}`;
          });
        } else {
          tempUrl = `${tempUrl}&searchParams[channel_type]=${!twitterFeeds && insightFeeds == 0 ? channel_type : (insightFeeds != 0?insightFeeds:3)
            }${twitterFeeds && insightFeeds == 0
              ? `&searchParams[twitter_type]=${getCorrectTwitterType(
                countType
              )}`
              : ""
            }`;
        }
      }
      if(widget.report_type === REPORT_TYPES.InfluencerWithDetail){
        tempUrl = `${tempUrl}&searchParams[influencer_verified]=true`;
      }
      if (tonality) {
        if (Array.isArray(tonality)) {
          tonality.forEach((t) => {
            tempUrl = `${tempUrl}&tonalityFilter[]=${t}`;
          });
        } else {
          tempUrl = `${tempUrl}&tonalityFilter[]=${tonality}`;
        }
      }
      if (from_username) {
        tempUrl = `${tempUrl}&searchParams[from_username]=${from_username}`;
      }

      if (keywords) {
        tempUrl = `${tempUrl}&searchParams[keyword]=${keywords}`;
      }
      if (language) {
        if (Array.isArray(language)) {
          language.forEach((lang) => {
            tempUrl = `${tempUrl}&searchParams[language][]=${lang}`;
          });
        } else {
          tempUrl = `${tempUrl}&searchParams[language]=${language}`;
        }
      }
      if (country) {
        tempUrl = `${tempUrl}&searchParams[country]=${country}`;
      }
      return tempUrl;
    },
    [
      channel_type,
      country,
      from_date,
      from_username,
      keywords,
      language,
      selectedClient,
      to_date,
      tonality,
      topic_ids,
      type,
    ]
  );

  const fetchSocialFeedsFilterData = useCallback(
    (preserveData, limit) => {
      setFeeds({ ...feeds, loading: true });
      httpGet(getFeedSearchUrl(preserveData, limit))
        .then(({ data }) => {
          if (data) {
            const {
              pagination: { total, page, pages },
            } = data;
            const articleList = (data && data.data) || [];
            const updatedList = !preserveData
              ? articleList
              : [...feeds.data, ...articleList];
            setFeeds({
              data: updatedList,
              loading: false,
              error: null,
            });
            setPaginationData(total);
            if (page == pages) {
              setShowViewMore(false);
            } else {
              setShowViewMore(true);
            }
            setGroupedSelectedArticle(groupBy(updatedList, "id"));
          }
        })
        .catch((e) => {
          setFeeds({
            data: [],
            loading: false,
            error: e,
          });
          console.log("[Error in Social feeds search]: ", e);
        })
        .finally(() => {
          //  setIsLoading(false);
        });
    },
    [feeds, getFeedSearchUrl]
  );

  const getSocialMultiTopicAPIUrl = useCallback(() => {
    const sDate = getSocialApiDateFormat(from_date);
    const eDate = getSocialApiDateFormat(to_date);
    const topicId = topic_ids;
    const client_id = selectedClient && selectedClient.id;
    let tempUrl = `${unifiedEnvConfig.FETCH_SOCIAL_FEEDS}?client_id=${client_id}&page=${offset}&perPage=${SOCIAL_PERPAGE_LIMIT}&searchParams[from_date]=${sDate}&searchParams[to_date]=${eDate}&searchParams[type]=${type}`;

    topicId.forEach((t) => {
      tempUrl = `${tempUrl}&searchParams[topic_ids][]=${t}`;
    });

    if (channel_type) {
      if (Array.isArray(channel_type)) {
        channel_type.forEach((cType) => {
          tempUrl = `${tempUrl}&searchParams[channel_type][]=${cType}`;
        });
      } else {
        tempUrl = `${tempUrl}&searchParams[channel_type][]=${channel_type}`;
      }
    }
    if (keywords) {
      //Since, # is a reserved query string, need to send it as an encobd string
      tempUrl = `${tempUrl}&searchParams[keyword]=${encodeURIComponent(
        keywords
      )}`;
    }

    if (language && language.length) {
      if (Array.isArray(language)) {
        language.forEach((l) => {
          const langId = getKeyByValue(LANGUAGE_CODES, l);
          if (langId) {
            tempUrl = `${tempUrl}&searchParams[language]=${langId}`;
          }
        });
      } else {
        let langId = getKeyByValue(LANGUAGE_CODES, language);
        if (langId) {
          tempUrl = `${tempUrl}&searchParams[language]=${langId}`;
        }
      }
    }
    if (country && country.length) {
      tempUrl = `${tempUrl}&searchParams[country]=${country}`;
    }

    if (tonality) {
      if (Array.isArray(tonality)) {
        tonality.forEach((t) => {
          tempUrl = `${tempUrl}&searchParams[tonality][]=${t}`;
        });
      } else {
        tempUrl = `${tempUrl}&searchParams[tonality]=${tonality}`;
      }
    }

    return tempUrl;
  }, [
    channel_type,
    country,
    from_date,
    keywords,
    language,
    offset,
    selectedClient,
    to_date,
    tonality,
    topic_ids,
    type,
  ]);

  const fetchSocialWordcloudFeeds = useCallback(
    (preserveData) => {
      if (topic_ids) {
        if (!preserveData) {
          setGroupedSelectedArticle({});
          setFeeds({
            data: [],
            loading: true,
          });
        } else {
          setFeeds({ ...feeds, loading: true });
        }
        httpGet(getSocialMultiTopicAPIUrl())
          .then(({ data }) => {
            if (data) {
              let allFeeds = [...data.data];
              allFeeds = allFeeds.filter(
                (elm) => elm.feeds && elm.feeds.length && elm
              );
              setFeeds({
                data: allFeeds,
                loading: false,
                error: null,
              });
            }
          })
          .catch((e) => {
            console.log("[Error in Social feeds search]: ", e);
          });
      }
    },
    [feeds, getSocialMultiTopicAPIUrl, topic_ids]
  );

  const renderSingleTopicFeeds = () => {
    return (
      <>
        {Object.keys(groupedSelectedArticle).map((news, index) => {
          if (!news) {
            return null;
          }
          let singleNewsGroup = groupedSelectedArticle[news];
          singleNewsGroup = [...singleNewsGroup].sort(function (a, b) {
            var editionA = a.edition && a.edition.toUpperCase();
            var editionB = b.edition && b.edition.toUpperCase();
            if (editionA < editionB) {
              return -1;
            }
            if (editionA > editionB) {
              return 1;
            }
            return 0;
          });
          const singleNews = singleNewsGroup && singleNewsGroup[0];
          const editionList =
            singleNewsGroup && singleNewsGroup.map((el) => el && el.edition);

          if (isSocial) {
            const similarArticles = Object.values(groupedSelectedArticle);
            const allArticleList = similarArticles.map((e) => {
              const { channel_type, id } = e[0] || {};
              return `${channel_type}/${id}?entityName="${clickedEntityName}"`;
            });
            return (
              <div key={index} className="singleNewsRow printNewsRow">
                <SingleSocialFeedItem
                  key={singleNews.id}
                  feed={singleNews}
                  selectedFeeds={selectedFeeds}
                  onFeedSelect={handleSelectedFeeds}
                  allArticleList={allArticleList}
                  forEmbedArticles
                  entityName={clickedEntityName}
                  onSingleFeedSelect={onSingleFeedSelect}
                />
              </div>
            );
          }
          if (isBlogAndForum) {
            const similarArticles = Object.values(groupedSelectedArticle);
            const allArticleList = similarArticles.map((e) => {
              const { channel_type, id } = e[0] || {};
              return `${channel_type}/${id}?entityName="${clickedEntityName}"`;
            });
            return (
              <div key={index} className="singleNewsRow printNewsRow">
                <BlogsAndForumFeedItem
                  key={singleNews.id}
                  feed={singleNews}
                  selectedFeeds={selectedFeeds}
                  onFeedSelect={handleSelectedFeeds}
                  allArticleList={allArticleList}
                  forEmbedArticles
                  entityName={clickedEntityName}
                  clientId={selectedClientId}
                />
              </div>
            );
          }
          if (isPrintAndOnline) {
            const allArticleList =
              feeds.data &&
              feeds.data.map(
                ({ article_id, client_id, entity_id, Forclient_id }) =>
                  `${type == V_ONLINE
                    ? MEDIA_TYPES.ONLINE_MV
                    : MEDIA_TYPES.PRINT_MV
                  }/${client_id || Forclient_id}-${article_id}-${entity_id}`
              );

            return (
              <div key={index} className="singleNewsRow printNewsRow">
                <SingleFeedItem
                  forEmbedArticles
                  key={index}
                  isPrint={type == VERTICALS.V_PRINT}
                  isOnline={type == VERTICALS.V_ONLINE}
                  feed={singleNews}
                  editionList={editionList}
                  allArticleList={allArticleList}
                  singleNewsGroup={groupedSelectedArticle[news]}
                  selectedFeeds={selectedFeeds}
                  onFeedSelect={handleSelectedFeeds}
                />
              </div>
            );
          }
        })}
      </>
    );
  };

  const renderWorldMapFeeds = () => {
    return (
      selectedCountryFeeds &&
      selectedCountryFeeds.map((feed, index) => {
        if (isSocial) {
          const similarArticles = selectedCountryFeeds;
          const allArticleList = similarArticles.map((e) => {
            const { channel_type, id } = e || {};
            return `${channel_type}/${id}?entityName="${e.topic_name}"`;
          });
          return (
            <div key={index} className="singleNewsRow printNewsRow">
              <SingleSocialFeedItem
                key={feed.id}
                feed={feed}
                selectedFeeds={selectedFeeds}
                onFeedSelect={handleSelectedFeeds}
                allArticleList={allArticleList}
                forEmbedArticles
                entityName={feed.topic_name || ""}
                onSingleFeedSelect={onSingleFeedSelect}
              />
            </div>
          );
        }
        if (isBlogAndForum) {
          const similarArticles = selectedCountryFeeds;
          const allArticleList = similarArticles.map((e) => {
            const { channel_type, id } = e || {};
            return `${channel_type}/${id}?entityName="${clickedEntityName}"`;
          });
          return (
            <div key={index} className="singleNewsRow printNewsRow">
              <BlogsAndForumFeedItem
                key={feed.id}
                feed={feed}
                selectedFeeds={selectedFeeds}
                onFeedSelect={handleSelectedFeeds}
                allArticleList={allArticleList}
                forEmbedArticles
                entityName={clickedEntityName}
                clientId={selectedClientId}
              />
            </div>
          );
        }
      })
    );
  };

  const formatArticleCount = (count = 0) => {
    if (typeof count == "undefined") {
      return 0;
    }
    return ` (${count})`;
  };

  const getArticleCount = () => {
    if (!useMutipleTopicsApi) {
      if (hasWorldMapData()) {
        return formatArticleCount(selectedCountryFeeds.length);
      } else if (!feeds.loading) {
        return formatArticleCount(paginationData);
      }
      return null;
    } else return null;
  };

  const isMAVOrCCM = useCallback(() => {
    if (!twitterFeeds && insightFeeds == 0) {
      const reportLabel =
        widget.report_type.toString().toLowerCase() ||
        widget.name.toString().toLowerCase();
      return (
        reportLabel.indexOf("ccm") == -1 && reportLabel.indexOf("mav") == -1
      );
    } else if (twitterFeeds || insightFeeds != 0) {
      return true;
    }
  }, [widget]);

  const renderArticleList = () => {
    if (!showFeedsList) {
      return null;
    }
    return (
      <div className="embededFeedListWrap">
        <div className="eflHeader">
          <div className="eflHeaderLeft">
            {!feeds.error && (
              <h5>
                <span className="circle"></span> Contributed Feeds -
                {clickedEntityName || selectedFilter || ""}
                {getArticleCount()}
              </h5>
            )}
          </div>
          <div className="eflHeaderRight c-feed-shareicon">
            <ShareArticle
              article={selectedFeeds}
              onShareSuccess={() => {
                setSelectedFeeds([]);
                setSelectedFeedsGroup([]);
              }}
              isSocial={isSocial}
              isBlogAndForum={isBlogAndForum}
            />
          </div>
        </div>
        <div className="embededFeedList">
          {feeds.loading && <Loader />}
          {worldMapData
            ? renderWorldMapFeeds()
            : useMutipleTopicsApi
              ? renderTopicWiseFeeds()
              : renderSingleTopicFeeds()}
          {feeds.error || (!feeds.loading && !feeds.data) ? (
            <NoDataMessage
              text="No data found"
              subtext="Try using different settings"
            />
          ) : (
            showPagination && (
              <div className="nextPrevPagination">
                <Button
                  className="btn btnBlue"
                  onClick={() => handlePagination("+")}
                  disabled={feeds.loading}
                >
                  {feeds.loading ? "Loading..." : "View More"}
                </Button>
              </div>
            )
          )}
        </div>
      </div>
    );
  };

  const renderTopicWiseFeeds = () => {
    return (
      <div className="accordion accordionListWrap socialAccordionWrap">
        {feeds.data.map((singleFeedGroup, index) => {
          const {
            topic: { name = "", id = "" } = {},
            feeds,
            total,
          } = singleFeedGroup;
          const data = {
            entityName: name,
            entityId: id,
            socialData: isSocial ? feeds : null,
            blogsAndForumData: isBlogAndForum ? feeds : null,
            type,
            total: total,
          };
          const allArticleList = singleFeedGroup.feeds.map(
            (e) =>
              `${e.channel_type}/${e.id}?entityName="${singleFeedGroup.topic.name}"`
          );
          const embeddedArticleFilters = {
            embTonality: tonality,
            embLanguage: language,
            embChannelType: channel_type,
            embCountry: country,
            embTopicIds: topic_ids,
            embKeywords: keywords,
          };
          return (
            <TopicWiseNewsContainer
              listkey={index + 1}
              entityFeeds={data}
              activeKey={activeKey}
              setActiveKey={setActiveKey}
              allArticleList={allArticleList}
              onFeedSelect={handleSelectedFeeds}
              selectedFeeds={selectedFeeds}
              selectedFeedsGroup={selectedFeedsGroup}
              setSelectedFeedsGroup={setSelectedFeedsGroup}
              handleFeedGroupClick={handleFeedGroupClick}
              isSocial={isSocial}
              isBlogsAndForum={isBlogAndForum}
              toDate={to_date}
              fromDate={from_date}
              forEmbedArticles
              onSingleFeedSelect={onSingleFeedSelect}
              embeddedArticleFilters={embeddedArticleFilters}
              mergePaginatedFeedsToCurrentList={
                mergePaginatedFeedsToCurrentList
              }
              isSelectAll={isSelectAll}
              setIsSelectAll={setIsSelectAll}
            />
          );
        })}
      </div>
    );
  };

  const handleSelectedFeeds = (selected, feedlist) => {
    let tempFeedsToShare = {};
    if (selected) {
      if (!Array.isArray(feedlist)) {
        tempFeedsToShare = [feedlist];
      } else {
        tempFeedsToShare = feedlist;
      }
      setSelectedFeeds([...selectedFeeds, ...tempFeedsToShare]);
    } else {
      if (!Array.isArray(feedlist)) {
        if (isPrintAndOnline) {
          setSelectedFeeds(
            selectedFeeds.filter((n) => n.article_id != feedlist.article_id)
          );
        } else {
          setSelectedFeeds(selectedFeeds.filter((n) => n.id != feedlist.id));
        }
      } else {
        let tempArr = [...selectedFeeds];
        feedlist.forEach((element) => {
          tempArr = tempArr.filter((n) => {
            if (isPrintAndOnline) {
              if (n.article_id !== element.article_id) return n;
            } else {
              if (n.id !== element.id) return n;
            }
          });
        });
        setSelectedFeeds(tempArr);
      }
    }
  };

  const handlePagination = (type) => {
    if (type === "+") {
      setoffset(offset + 1);
      fetchFeeds(true, offset + 1);
    } else {
      const updatedList =
        feeds.data && feeds.data.splice(0, MAX_FEED_COUNT * (offset - 1));
      setFeeds({
        data: updatedList,
        loading: false,
        error: null,
      });
      if (isPrintAndOnline) {
        setGroupedSelectedArticle(
          groupBy(updatedList, isPrint ? "headline" : "article_id")
        );
      } else {
        setGroupedSelectedArticle(groupBy(updatedList, "id"));
      }
      setoffset(offset - 1);
    }
  };
  const handleFeedGroupClick = (groupIdentifier) => {
    if (selectedFeedsGroup.indexOf(groupIdentifier) !== -1) {
      setSelectedFeedsGroup(
        selectedFeedsGroup.filter((g) => g !== groupIdentifier)
      );
    } else {
      setSelectedFeedsGroup([...selectedFeedsGroup, groupIdentifier]);
    }
  };

  const onSingleFeedSelect = (selected, feedlist, entityId) => {
    let tempFeedsToShare = {};
    if (selected) {
      if (!Array.isArray(feedlist)) {
        tempFeedsToShare = [feedlist];
      } else {
        tempFeedsToShare = feedlist.map((elm) => {
          const {
            id,
            page_details,
            channel_type,
            attachments,
            message,
            favourites,
            tags,
          } = elm;
          return {
            id,
            topicName: page_details && page_details.name,
            message,
            channel_type,
            attachments,
            entityId,
            favourites,
            tags,
            isBulkUpdate: selected,
          };
        });
      }
      setSelectedFeeds([...selectedFeeds, ...tempFeedsToShare]);
    } else {
      if (!Array.isArray(feedlist)) {
        setSelectedFeeds(selectedFeeds.filter((n) => n.id != feedlist.id));
      } else {
        let tempArr = [...selectedFeeds];
        feedlist.forEach((element) => {
          tempArr = tempArr.filter((n) => {
            if (n.id !== element.id) return n;
          });
        });
        setSelectedFeeds(tempArr);
      }
    }
  };

  const mergePaginatedFeedsToCurrentList = (allFeeds, entityId) => {
    let modifiedList = [];
    feeds.data.forEach((item) => {
      if (item.topic.id == entityId) {
        item.feeds = allFeeds;
      }
      modifiedList.push(item);
    });
    setFeeds({ ...feeds, data: modifiedList });
    isSelectAll && handleSelectedFeeds(isSelectAll, modifiedList, entityId);
  };

  const contributedWidgetFilter = {
    preSelectedJournalist: {
      label:
        widget.report_type == REPORT_TYPES.JournalistAnalysisPrint ||
          widget.report_type == REPORT_TYPES.EditionWiseNOATrend
          ? ottChannel
          : reporter,
      value: reporterId,
    },
    preSelectedEdition: selectedInlineEdition,
    preSelectedState: selectedInlineState,
    preSelectedPublication: selectedInlinePublication,
    preSelectedInlineInfluencerEntity: selectedInlineInfluencerEntity,
    preSelectedInlineWCEntity: selectedInlineWCEntity,
  };
  return (
    <Modal
      onHide={onCancel}
      show={true}
      backdrop="static"
      keyboard={false}
      dialogClassName="customModal modal-90w"
      className="feedContributingModal"
    >
      <Modal.Header>
        <span className="btnClose" onClick={() => onCancel(false)}>
          <ModalCloseIcon />
        </span>
      </Modal.Header>
      <Modal.Body>
        <EmbededFeedWidget
          widget={widget}
          setFromUserName = {(e) => {
            setFromUserName(e)
          }}
          fromUserName={fromUserName}
          setEmbededFeedsParams={setEmbededFeedsParams}
          inlineGraphTypeOptions={inlineGraphTypeOptions}
          onWidgetDelete={onWidgetDelete}
          setWidgetCreationStatus={setWidgetCreationStatus}
          fetchWidgets={fetchWidgets}
          selectedDataType={selectedDataType}
          preSelectedWCType={selectedInlineWCType}
          countryWiseFeeds={countryWiseFeeds}
          isAnalysisReport={isAnalysisReport}
          embededFeedsParams={feedsParams || embededFeedsParams}
          contributedWidgetFilter={contributedWidgetFilter}
          twitterFeeds={twitterFeeds}
          insightFeeds={insightFeeds}
          tonality={tonalities}
          topicId={topicId}
          tabData={tabData}
          widgetApiInProgress={widgetApiInProgress}
          startRange={startRange}
          endRange={endRange}
        />
        {renderArticleList()}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onCancel()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

EmbededFeedsList.defaultProps = {
  feedsParams: {
    edition_ids: "",
    to_date: new Date(),
    from_date: new Date(),
    publication: [],
    tonality: "",
  },
};
